import { render } from "./matching-form-page.vue?vue&type=template&id=d6b1131e&scoped=true"
import script from "./matching-form-page.vue?vue&type=script&lang=js"
export * from "./matching-form-page.vue?vue&type=script&lang=js"

import "./matching-form-page.vue?vue&type=style&index=0&id=d6b1131e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b1131e"]])

export default __exports__